// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

import "trix"
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Leaflet for maps
import L from "leaflet"
window.L = L

// Mux Player web component for video playback
import "@mux/mux-player"